import axios from 'axios';

const _axios = axios.create();
const baseURL = process.env.REACT_APP_BASEURL;

// Portal-specific Axios — uses portalToken, NOT the business token
const PortalRequest = async (payload) => {
    const token = localStorage.getItem('portalToken');

    const config = {
        headers: {
            'Content-Type': 'application/json',
            ...payload.headers,
        },
        method: payload.method,
        url: payload.url,
        data: payload.data,
    };

    if (token) {
        config.headers['Authorization'] = `Bearer ${token}`;
    }

    try {
        const response = await _axios(config);
        return response;
    } catch (err) {
        if (err.response?.status === 401 && !payload.url.includes('/portal/auth')) {
            localStorage.removeItem('portalToken');
            window.location.href = '/customer-side/login';
        }
        throw err;
    }
};

export { baseURL };
export default { PortalRequest };
